import axios from 'axios'

import * as Auth from '@/shared/auth'
import * as Helper from '@/shared/helper'

const getLangCodeArr = async ()=>{
  try{
	  let res = await axios.get(`${Helper.envi.VUE_APP_API_URL}/Lang/Codes`)
    return res.data.data
  }catch(err){
    console.log(err.response)
    return err.response
  }
}

export {
  getLangCodeArr
}